<!-- Spacer -->
<div
  [ngClass]="item.classes?.wrapper"
  class="fuse-vertical-navigation-item-wrapper"></div>
